import { ContentLoader, OverlayTrigger, Select, Tooltip } from "@rio-cloud/rio-uikit";
import { OccurrenceStatus } from "../../../types";
import { typesOcorrenceStatusIds } from "../../../constants";
import moment from 'moment';
import useDarkMode from "../../../../../hooks/useDarkMode";
import { useIntl } from "react-intl";

interface Props {
    status?: OccurrenceStatus;
    createdAt?: string;
    isLoading: boolean;
    users: UserTas[];
    selectedUser?: string[];
    handleSelectedUser: (user?: UserTas) => void;
    isControlTower: boolean;
    isVwEmail: boolean;
}

export type UserTas = {
    id: string;
    label: string;
};

const CardStatus = ({ status, createdAt, isLoading, users, handleSelectedUser, selectedUser, isControlTower, isVwEmail }: Props) => {
    const isDarkMode = useDarkMode();
    const intl = useIntl();
    const statusLabelId = typesOcorrenceStatusIds[status as keyof typeof typesOcorrenceStatusIds];

    const getHoursDifference = (utcDate?: string) => {
        if (!utcDate) {
            return '';
        }

        const localDate = moment.utc(utcDate).local();

        const duration = moment.duration(moment().diff(localDate));

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        if (hours < 1) {
            return `${minutes} min`;
        }

        return `${hours}h ${minutes}min`;
    };

    const getAssignRestrictionMessage = () => {
        if (!isControlTower) {
            return intl.formatMessage({ id: "intl-msg:support.cardStatus.noPermissionAssign" });
        }
        if (!isVwEmail) {
            return intl.formatMessage({ id: "intl-msg:support.cardStatus.restrictedToVw" });
        }
        return '';
    };

    return (
        <div className="border padding-15 display-flex flex-column rounded height-100pct justify-content-between">
            <div className="display-flex flex-column">
                <span className="text-medium text-size-16">{intl.formatMessage({ id: "intl-msg:support.cardStatus.currentStatus" })}</span>
                <div className="margin-top-10">
                    {isLoading ? (
                        <div className="width-100" style={{ borderRadius: 80, overflow: 'hidden', height: 20 }}>
                            <ContentLoader className="width-100pct height-100pct" />
                        </div>
                    ) : (
                        <span style={{ background: isDarkMode ? '#0c2d3d' : '#B9E6FE', color: isDarkMode ? '#7cd4fd' : '#026AA2', borderRadius: 80, padding: '2px 8px' }} className="width-auto">{statusLabelId ? intl.formatMessage({ id: statusLabelId }) : '-'}</span>

                    )}
                </div>
            </div>

            <div>
                <div className="display-flex align-items-center gap-5 margin-bottom-10">
                    <label htmlFor="type" className="text-size-14 line-height-20 text-color-dark margin-bottom-0">
                        {intl.formatMessage({ id: "intl-msg:support.constants.field.assignedTo" })}
                    </label>
                    {!(isControlTower && isVwEmail) && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="assign-restricted">{getAssignRestrictionMessage()}</Tooltip>}
                        >
                            <span
                                className="rioglyph rioglyph-info-sign text-color-dark cursor-pointer text-size-16"
                                style={{ display: 'inline-flex', alignItems: 'center' }}
                            />
                        </OverlayTrigger>
                    )}
                </div>
                {isControlTower ? (
                    <Select
                        id="type"
                        bsSize='lg'
                        value={selectedUser}
                        onChange={(item) => handleSelectedUser(item)}
                        options={users || []}
                        placeholder={intl.formatMessage({ id: "intl-msg:support.cardStatus.user" })}
                        disabled={!isVwEmail}
                        useClear
                        useFilter
                    />
                ) : (
                    <span className="text-color-dark text-size-16">-</span>
                )}
            </div>

            <div className="display-flex flex-column">
                <span className="text-size-14 line-height-20 text-color-dark">{intl.formatMessage({ id: "intl-msg:support.cardStatus.timeSinceOpening" })}</span>
                {isLoading ? (
                    <ContentLoader className="max-width-100" />
                ) : (
                    <span className="text-size-16 line-height-22 text-color-darker">{getHoursDifference(createdAt)}</span>
                )}
            </div>
        </div>
    )
};

export default CardStatus